import { useMutation } from "react-query";
import { updateDomainName } from "actions/Utilities/EmailDomain";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  editStateEmailDomain,
  emailDomainReFetching,
} from "../atoms/atoms";
import { IEmailDomain } from "../types";
import { toast } from "components/toastNotification";

const useEditEmailDomain = () => {
  // return useMutation(updateDomainName);
  
  const setActionEditState = useSetRecoilState(editStateEmailDomain);
  const [isReFetching, setIsReFetching] = useRecoilState(
    emailDomainReFetching
  );

  const { mutate } = useMutation(
    (newData: IEmailDomain) => updateDomainName(newData),
    {
      onSuccess: (res) => {

        if (typeof res == "object") {
          toast.fire(
            "Updating Domain Name failed",
            `${res.Message}`,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Domain Name Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Domain Name Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating Domain Name failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating Domain Name failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating Domain Name failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire(
                "Updating Domain Name failed",
                `${res}`,
                "error"
              );
          }
        }
        setActionEditState(false);
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire(
          "Update Domain Name failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );
  return mutate;
};

export default useEditEmailDomain;
